import { useEffect } from 'react';

/**
 * Magnetic hover effect for elements with `.magnetic` class.
 * Subtle pull toward cursor on hover. Desktop only, respects reduced motion.
 */
export const useMagnetic = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const isTouch = window.matchMedia('(hover: none)').matches;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isTouch || reducedMotion) return;

    const elements = document.querySelectorAll('.magnetic');
    const cleanups = [];

    elements.forEach((el) => {
      let rafId;
      const strength = 0.25;

      const onMove = (e) => {
        const rect = el.getBoundingClientRect();
        const x = e.clientX - (rect.left + rect.width / 2);
        const y = e.clientY - (rect.top + rect.height / 2);
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          el.style.transform = `translate3d(${x * strength}px, ${y * strength}px, 0)`;
        });
      };

      const onLeave = () => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          el.style.transform = 'translate3d(0, 0, 0)';
        });
      };

      el.addEventListener('mousemove', onMove);
      el.addEventListener('mouseleave', onLeave);

      cleanups.push(() => {
        el.removeEventListener('mousemove', onMove);
        el.removeEventListener('mouseleave', onLeave);
        cancelAnimationFrame(rafId);
        el.style.transform = '';
      });
    });

    return () => cleanups.forEach((fn) => fn());
  }, []);
};
